import { profitLoss } from "../footer/AccountFooter";

export const calculateAccountMetrics = (accountSummary) => {
  const floatingProfitLoss = [...profitLoss].reduce(
    (acc, [, value]) => acc + parseFloat(value || 0),
    0
  );

  const calculatedEquity = accountSummary?.balance
    ? parseFloat(accountSummary.balance) + floatingProfitLoss
    : 0;

  const calculatedMarginLevel =
    calculatedEquity && accountSummary?.usedMargin
      ? (calculatedEquity / parseFloat(accountSummary.usedMargin)) * 100
      : 0;

      const freeMargin = calculatedEquity ? (parseFloat(accountSummary.balance) + parseFloat(floatingProfitLoss) - parseFloat(accountSummary.usedMargin))?.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0.00';

  return {
    floatingProfitLoss,
    calculatedEquity,
    calculatedMarginLevel,
    freeMargin
  };
};
